import FeatureCatalog from "../Components/FeatureCatalog/FeatureCatalog";

const FeatureCatalogPage = () => {
  return <FeatureCatalog />;
};

export default FeatureCatalogPage;
